export default __webpack_public_path__ + "static/media/large-logo-light.e7209b4d.png";